import { render, staticRenderFns } from "./DirectiveDashboardMatters.vue?vue&type=template&id=364f5717&scoped=true"
import script from "./DirectiveDashboardMatters.vue?vue&type=script&lang=js"
export * from "./DirectiveDashboardMatters.vue?vue&type=script&lang=js"
import style0 from "./DirectiveDashboardMatters.vue?vue&type=style&index=0&id=364f5717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364f5717",
  null
  
)

export default component.exports